// https://www.npmjs.com/package/trailz
// javascript-obfuscator bundle.js --output bundle.js

export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = true;
    public static readonly DIFFICULTY_OUTPUT = false;
    public static readonly VERBOSE = false;
    public static readonly SHOW_DEBUG_GEOMETRY = false;
    public static readonly SLOW_MOTION = false;

    public static readonly GAME_WIDTH = 450;
    public static readonly GAME_HEIGHT = 800;

    public static SPONSOR_GAMEPIX = "gamepix";
    public static SPONSOR_GLANCE = "Glance";
    public static SPONSOR_FUNO = "funo";
    public static SPONSOR_NONE = "sponsor";
    public static GAME_DISTRIBUTION = "GAME DISTRIBUTION";
    public static SPONSOR = GameConstants.SPONSOR_NONE;

    public static readonly COLOR_NONE = 0xE0FAFF;
    public static readonly COLOR_TIME = 0x00bbfb;
    public static readonly COLOR_POINTS = 0xffd71c;
    public static readonly COLOR_PENALTY = 0xff0000;

    public static readonly GOAL_NONE = "goal none";
    public static readonly GOAL_POINTS = "goal points";
    public static readonly GOAL_TIME = "goal time";

    public static readonly START_TIME = 120; 
    public static readonly PASSED_LEVEL_EXTRA_TIME = 20;
    public static readonly POWER_UP_EXTRA_TIME = 25;
    public static readonly PASSED_LEVEL_EXTRA_POINTS = 250;

    public static readonly GOAL_CYAN = "goal cyan";
    public static readonly GOAL_RED = "goal red";
    public static readonly GOAL_BLACK = "goal black";

    public static readonly DIR_UP = "up";
    public static readonly DIR_DOWN = "down";
    public static readonly DIR_LEFT = "left";
    public static readonly DIR_RIGHT = "right";

    public static readonly SAVED_GAME_DATA_KEY = "maze-speedrun-data";
}
